import React, { useContext } from 'react';
import styles from './SnackBarDescription.module.scss';
import { SnackBarContext } from '../SnackBar/SnackBar';
import cs from 'classnames';
export default function SnackBarDescription(_ref) {
  var className = _ref.className,
    children = _ref.children;
  var size = useContext(SnackBarContext);
  return /*#__PURE__*/React.createElement("div", {
    className: cs(className, styles.description, styles["description--".concat(size)])
  }, children);
}